// extracted by mini-css-extract-plugin
export default {"container":"style_container__WCjqU","title":"style_title__hiFpl"};